// extracted by mini-css-extract-plugin
module.exports = {"container":"i_GX","content":"i_GY"};